export default "__VITE_ASSET__AoCahOjT__"